<div class="container">
  <div class="col-sm-12 webview" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">
      Last question!
      <!-- <a
        style="color: #ed1976; text-decoration: underline"
        href="javascript:void(0);"
        (click)="getMonthsDetails()"
      >
        Click here</a
      > -->
      What was your energy usage
    </h1>
    <h1 class="text-center font-weight-normal-calibre mt-0 questxt">
      for the last 12 months?
    </h1>
    <div class="row m-auto" id="form">
      <div class="col-sm-6 m-auto blocks3">
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let j of [0, 4, 8]; let i = index"
        >
          <div *ngIf="months[j]">
          <input
            type="number"
            id="{{ months[j].month }}"
            min="1"
            class="valueinput floating-input monthrender"
            tabindex="i"
            [(ngModel)]="months[j].usage"
            (keyup)="onKey($event)"
            (ngModelChange)="enableButton(months[j].month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ months[j].monthValue }}"
          />
          <label class="floating-label"
            >{{ months[j].monthformat }} - {{ months[j].year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
        </div>
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let j of [1, 5, 9]; let i = index"
        >
          <div *ngIf="months[j]">
          <input
            type="number"
            id="{{ months[j].month }}"
            min="1"
            class="valueinput floating-input monthrender"
            tabindex="i"
            [(ngModel)]="months[j].usage"
            (keyup)="onKey($event)"
            (ngModelChange)="enableButton(months[j].month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ months[j].monthValue }}"
          />
          <label class="floating-label"
            >{{ months[j].monthformat }} - {{ months[j].year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
        </div>
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let j of [2, 6, 10]; let i = index"
        >
          <div *ngIf="months[j]">
          <input
            type="number"
            id="{{ months[j].month }}"
            min="1"
            class="valueinput floating-input monthrender"
            tabindex="i"
            [(ngModel)]="months[j].usage"
            (keyup)="onKey($event)"
            (ngModelChange)="enableButton(months[j].month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ months[j].monthValue }}"
          />
          <label class="floating-label"
            >{{ months[j].monthformat }} - {{ months[j].year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
        </div>
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let j of [3, 7, 11]; let i = index"
        >
          <div *ngIf="months[j]">
          <input
            type="number"
            id="{{ months[j].month }}"
            min="1"
            class="valueinput floating-input monthrender"
            tabindex="i"
            [(ngModel)]="months[j].usage"
            (keyup)="onKey($event)"
            (ngModelChange)="enableButton(months[j].month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ months[j].monthValue }}"
          />
          <label class="floating-label"
            >{{ months[j].monthformat }} - {{ months[j].year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
        </div>
      </div>
    </div>
    <!-- <div class="row m-auto" id="form">
      <div class="col-sm-6 m-auto blocks3">
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let month of months | slice: 6:12; let i = index"
        >
          <input
            type="number"
            id="{{ month.month }}"
            min="1"
            class="valueinput inputText monthrender"
            tabindex="i"
            [(ngModel)]="month.usage"
            (ngModelChange)="enableButton(month.month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ month.monthValue }}"
          /><label class="floating-label"
            >{{ month.monthformat }} - {{ month.year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
      </div>
    </div> -->

    <div *ngIf="showbutton" class="col-12 text-center">
      <a href="javascript:void(0);" (click)="next()" id="nextButton">
        <button
          class="btn next mr-2 ml-2 my-3 disabledButton font22"
          [ngClass]="{ sectbtn: user_bot }"
        >
          FINISH
        </button>
      </a>
    </div>
    <div class="mt-3">
      <div class="m-auto col-sm-4 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">ADVICE</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 pt-2 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0 mb-2">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box mt-3">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
      <!-- <p class="text-left actualqlargemsg mb-4">
        Enter actual usage below or
        <a
          style="color: #0055ff"
          href="javascript:void(0);"
          (click)="getMonthsDetails()"
        >
          click here </a
        >and have Eva estimate for you
      </p> -->
    </div>
  </div>
  <div class="row col-12 m-auto" id="form">
    <div
      class="form-group col-6 px-0 float-label-control"
      *ngFor="let j of [0, 6]; let i = index"
    >
      <div *ngIf="months[j]" class="col-12 pl-2 m-auto">
        <input
          type="tel"
          min="1"
          class="valueinput inputText monthrender"
          appFourDigitDecimaNumber
          [(ngModel)]="months[j].usage"
          id="{{ i }}"
          (ngModelChange)="enableButton(i)"
          placeholder=""
          (keydown)="goKey($event, i)"
          (keyup.enter)="next()"
        /><label class="floating-label"
          >{{ months[j].monthformat }} - {{ months[j].year }}</label
        >
        <font class="unitfont">kWh</font>
      </div>
    </div>
    <div
    class="form-group col-6 px-0 float-label-control"
    *ngFor="let j of [1, 7]; let i = index"
  >
    <div *ngIf="months[j]" class="col-12 pl-2 m-auto">
      <input
        type="tel"
        min="1"
        class="valueinput inputText monthrender"
        appFourDigitDecimaNumber
        [(ngModel)]="months[j].usage"
        id="{{ i }}"
        (ngModelChange)="enableButton(i)"
        placeholder=""
        (keydown)="goKey($event, i)"
        (keyup.enter)="next()"
      /><label class="floating-label"
        >{{ months[j].monthformat }} - {{ months[j].year }}</label
      >
      <font class="unitfont">kWh</font>
    </div>
  </div>
  <div
  class="form-group col-6 px-0 float-label-control"
  *ngFor="let j of [2, 8]; let i = index"
>
  <div *ngIf="months[j]" class="col-12 pl-2 m-auto">
    <input
      type="tel"
      min="1"
      class="valueinput inputText monthrender"
      appFourDigitDecimaNumber
      [(ngModel)]="months[j].usage"
      id="{{ i }}"
      (ngModelChange)="enableButton(i)"
      placeholder=""
      (keydown)="goKey($event, i)"
      (keyup.enter)="next()"
    /><label class="floating-label"
      >{{ months[j].monthformat }} - {{ months[j].year }}</label
    >
    <font class="unitfont">kWh</font>
  </div>
</div>
<div
class="form-group col-6 px-0 float-label-control"
*ngFor="let j of [3, 9]; let i = index"
>
<div *ngIf="months[j]" class="col-12 pl-2 m-auto">
  <input
    type="tel"
    min="1"
    class="valueinput inputText monthrender"
    appFourDigitDecimaNumber
    [(ngModel)]="months[j].usage"
    id="{{ i }}"
    (ngModelChange)="enableButton(i)"
    placeholder=""
    (keydown)="goKey($event, i)"
    (keyup.enter)="next()"
  /><label class="floating-label"
    >{{ months[j].monthformat }} - {{ months[j].year }}</label
  >
  <font class="unitfont">kWh</font>
</div>
</div>

<div
class="form-group col-6 px-0 float-label-control"
*ngFor="let j of [4, 10]; let i = index"
>
<div *ngIf="months[j]" class="col-12 pl-2 m-auto">
  <input
    type="tel"
    min="1"
    class="valueinput inputText monthrender"
    appFourDigitDecimaNumber
    [(ngModel)]="months[j].usage"
    id="{{ i }}"
    (ngModelChange)="enableButton(i)"
    placeholder=""
    (keydown)="goKey($event, i)"
    (keyup.enter)="next()"
  /><label class="floating-label"
    >{{ months[j].monthformat }} - {{ months[j].year }}</label
  >
  <font class="unitfont">kWh</font>
</div>
</div>

<div
class="form-group col-6 px-0 float-label-control"
*ngFor="let j of [5, 11]; let i = index"
>
<div *ngIf="months[j]" class="col-12 pl-2 m-auto">
  <input
    type="tel"
    min="1"
    class="valueinput inputText monthrender"
    appFourDigitDecimaNumber
    [(ngModel)]="months[j].usage"
    id="{{ i }}"
    (ngModelChange)="enableButton(i)"
    placeholder=""
    (keydown)="goKey($event, i)"
    (keyup.enter)="next()"
  /><label class="floating-label"
    >{{ months[j].monthformat }} - {{ months[j].year }}</label
  >
  <font class="unitfont">kWh</font>
</div>
</div>



    <div class="col-12 text-center">
      <a href="javascript:void(0);" (click)="next()">
        <button
          class="btn mr-2 ml-2 my-3 disabledButton font20 px-4"
          [ngClass]="{ sectbtn: user_bot }"
        >
          FINISH
        </button>
      </a>
    </div>
    <div class="col-xl-6">
      <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
        <img
          src="assets/images/flash.png"
          class="mb-1"
          style="margin-left: 48%"
        />
        <p class="text-center tiphead">ADVICE</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
